/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Typography,
  CardContent,
  TextField,
  MenuItem,
  LinearProgress,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { setProcessedOldDevice } from '../../helperFunctions';

export default ({ device, task }) => {
  const taskStarted = useSelector(state => state.tasks.taskStarted);
  const isTaskStarted = taskStarted.started && taskStarted.taskId === task.id;
  const data = useSelector(state => state.tasks.data);
  const featuresList = useSelector(state => state.features.featuresList);
  const dispatch = useDispatch();

  const {
    id,
    deviceType,
    serialNumber,
    mac,
    username,
    password,
    pin,
    ip,
    cardSerialNumber,
    hasCurrentlyUsedOption,
  } = device;

  const [newSerialNumber, setNewSerialNumber] = useState(serialNumber || '');
  const processedOldDevices = useSelector(state => state.tasks.data.processedOldDevices);
  const processedOldDevice = processedOldDevices.find(d => d.deviceId === id) || {
    deviceId: id,
    returnType: '',
    notReturnedReason: null,
    isValidForBackend: false,
    newSerialNumber: '',
    isCardMarkedAsReturned: cardSerialNumber && cardSerialNumber !== null,
  };

  const ReturnTypes = {
    Returned: 1,
    NotReturned: 2,
    Used: 3,
    Unknown: 4,
  };

  const isValidForBackend = (returnType, notReturnedReason, newManualSerialNumber) => {
    let isValidForBackendInternal = false;
    const hasSerialNumber =
      newManualSerialNumber != null &&
      newSerialNumber !== undefined &&
      newManualSerialNumber !== '';

    if (Number(returnType) && Number(returnType) === ReturnTypes.Returned) {
      if (hasSerialNumber) {
        isValidForBackendInternal = true;
        return isValidForBackendInternal;
      }
    } else if (Number(returnType) && Number(returnType) !== ReturnTypes.NotReturned) {
      isValidForBackendInternal = true;
      return isValidForBackendInternal;
    }

    if (Number(returnType) && Number(returnType) === ReturnTypes.NotReturned) {
      if (notReturnedReason && Number(notReturnedReason) && hasSerialNumber) {
        isValidForBackendInternal = true;
        return isValidForBackendInternal;
      }
    }

    return isValidForBackendInternal;
  };

  const renderActionFields = () => {
    switch (processedOldDevice ? processedOldDevice.returnType : null) {
      case 1:
        return (
          <TextField
            style={{ marginTop: '10px', marginBottom: '10px' }}
            id="outlined-basic"
            label="Serial number"
            variant="outlined"
            value={newSerialNumber}
            error={!newSerialNumber || newSerialNumber === ''}
            helperText="Въведете сериен номер"
            onChange={x => {
              setNewSerialNumber(x.target.value);

              const updatedProcessedOldDevice = {
                deviceId: id,
                returnType: processedOldDevice.returnType,
                notReturnedReason: processedOldDevice.notReturnedReason,
                isValidForBackend: isValidForBackend(
                  processedOldDevice.returnType,
                  processedOldDevice.notReturnedReason,
                  x.target.value
                ),
                newSerialNumber: x.target.value,
                isCardMarkedAsReturned: processedOldDevice.isCardMarkedAsReturned,
              };

              setProcessedOldDevice(updatedProcessedOldDevice, processedOldDevices, data, dispatch);
            }}
          />
        );
      case 2:
        return (
          <>
            <TextField
              style={{ marginTop: '10px', marginBottom: '10px' }}
              label="Причина"
              select
              fullWidth
              value={processedOldDevice ? processedOldDevice.notReturnedReason : null}
              error={!(processedOldDevice ? processedOldDevice.notReturnedReason : null)}
              onChange={x => {
                const updatedProcessedOldDevice = {
                  deviceId: id,
                  returnType: processedOldDevice.returnType,
                  notReturnedReason: Number(x.target.value),
                  isValidForBackend: isValidForBackend(
                    x.target.value,
                    Number(x.target.value),
                    newSerialNumber
                  ),
                  newSerialNumber,
                  isCardMarkedAsReturned: processedOldDevice.isCardMarkedAsReturned,
                };

                setProcessedOldDevice(
                  updatedProcessedOldDevice,
                  processedOldDevices,
                  data,
                  dispatch
                );
              }}
            >
              <MenuItem value={1}>Не е налично на адреса</MenuItem>
              <MenuItem value={2}>Отказва да го върне</MenuItem>
              <MenuItem value={3}>Повредено/счуепно оборудване</MenuItem>
            </TextField>
            <TextField
              style={{ marginTop: '10px', marginBottom: '10px' }}
              id="outlined-basic"
              label="Serial number"
              variant="outlined"
              value={newSerialNumber}
              error={!newSerialNumber || newSerialNumber === ''}
              helperText="Въведете сериен номер"
              onChange={x => {
                setNewSerialNumber(x.target.value);

                const updatedProcessedOldDevice = {
                  deviceId: id,
                  returnType: processedOldDevice.returnType,
                  notReturnedReason: processedOldDevice.notReturnedReason,
                  isValidForBackend: isValidForBackend(
                    processedOldDevice.returnType,
                    processedOldDevice.notReturnedReason,
                    x.target.value
                  ),
                  newSerialNumber: x.target.value,
                  isCardMarkedAsReturned: processedOldDevice.isCardMarkedAsReturned,
                };

                setProcessedOldDevice(
                  updatedProcessedOldDevice,
                  processedOldDevices,
                  data,
                  dispatch
                );
              }}
            />
          </>
        );
      case 3:
        return <></>;
      case 4:
        return <></>;

      default:
        return null;
    }
  };

  const { width } = useWindowDimensions();
  const fontSize = width <= 500 ? '4vw' : '20px';

  return (
    <CardContent key={id} style={{ marginBottom: '3px' }}>
      {deviceType && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Тип: {deviceType}
        </Typography>
      )}
      {serialNumber && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Сериен номер: {serialNumber}
        </Typography>
      )}
      {mac && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Мак адрес: {mac}
        </Typography>
      )}
      {username && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Username: {username}
        </Typography>
      )}
      {password && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Password: {password}
        </Typography>
      )}
      {pin && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          PIN: {pin}
        </Typography>
      )}
      {ip && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          IP: {ip}
        </Typography>
      )}
      {cardSerialNumber && (
        <>
          <Typography gutterBottom component="h2" style={{ fontSize }}>
            CardNo: {cardSerialNumber}
          </Typography>
          {processedOldDevice.returnType && processedOldDevice.returnType === ReturnTypes.Returned && (
            <FormControlLabel
              style={{ float: 'left' }}
              control={<Checkbox defaultChecked />}
              label="Взета карта?"
              onChange={() => {
                const updatedProcessedOldDevice = {
                  deviceId: id,
                  returnType: processedOldDevice.returnType,
                  notReturnedReason: processedOldDevice.notReturnedReason,
                  isValidForBackend: processedOldDevice.isValidForBackend,
                  newSerialNumber: processedOldDevice.newSerialNumber,
                  isCardMarkedAsReturned: !processedOldDevice.isCardMarkedAsReturned,
                };

                setProcessedOldDevice(
                  updatedProcessedOldDevice,
                  processedOldDevices,
                  data,
                  dispatch
                );
              }}
            />
          )}
        </>
      )}
      {!data.isCpeReturnLoading ? (
        isTaskStarted ? (
          <>
            <TextField
              label="Действия"
              select
              fullWidth
              value={processedOldDevice.returnType}
              error={!processedOldDevice.returnType}
              onChange={x => {
                const updatedProcessedOldDevice = {
                  deviceId: id,
                  returnType: Number(x.target.value),
                  notReturnedReason: null,
                  isValidForBackend: isValidForBackend(x.target.value, null, newSerialNumber),
                  newSerialNumber,
                  isCardMarkedAsReturned: processedOldDevice.isCardMarkedAsReturned,
                };

                setProcessedOldDevice(
                  updatedProcessedOldDevice,
                  processedOldDevices,
                  data,
                  dispatch
                );
              }}
            >
              {featuresList.loaded && !featuresList.features.includes('SAP_Downtime') && (
                <MenuItem value={1}>Взето оборудване</MenuItem>
              )}
              <MenuItem value={2}>Невзето оборудване</MenuItem>
              {hasCurrentlyUsedOption ? <MenuItem value={4}>Използва се</MenuItem> : null}
            </TextField>
            {renderActionFields()}
          </>
        ) : null
      ) : (
        <LinearProgress />
      )}
    </CardContent>
  );
};
